/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from '@angular/core';
import { ProductDigemidService } from '../product-of-digemid.service';
import {
  IProductDigemid,
  PRODUCTDIGEMID_TTL_ES
} from '../product-of-digemid.interface';
import { TableActionsTemplate } from 'src/app/@amiga-pyme/table-actions/templates/table-actions.template';
import { getTagColor } from '../../../../../helpers/tag-color.helpers';

@Component({
  selector: 'pg-digemid-products',
  templateUrl: './product-of-digemid.component.html'
})
export class ProductDigemidComponent extends TableActionsTemplate {
  constructor(private serviceBase: ProductDigemidService) {
    super(PRODUCTDIGEMID_TTL_ES, serviceBase);
  }

  async ngOnInit() {
    this.table.settings = {
      title: PRODUCTDIGEMID_TTL_ES,
      columns: [
        { header: 'Código', field: 'code' },
        { header: 'Nombre', field: 'name' },
        { header: 'Concentración', field: 'concentration' },
        { header: 'FormDet', field: 'form' },
        { header: 'FormSim', field: 'formSimp' },
        { header: 'Presentación', field: 'presentation' },
        { header: 'Laboratorio', field: 'laboratory' },
        { header: 'Fracción', field: 'fractions' },
        { header: 'Condición', field: 'condition', tag: 'tagStatus' }
      ],
      filterColumns: true
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: IProductDigemid[]) => {
        data = data.map((item) => {
          item.tagStatusColor = getTagColor(item.conditionCode);
          return item;
        });
        this.table.data = data;
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
